import { useContext } from 'react';

import { PRODUCTS_FILTERS } from '../components/business/product/list/ProductsListFilters';
import {
  LOCAL_STORAGE_FILTERS,
  LOCAL_STORAGE_FILTERS_DEFVAL,
  LOCAL_STORAGE_PRECART,
  LOCAL_STORAGE_PRECART_DEFVAL,
  ROUTE_P1_PRODUCT_SELECTION,
  ROUTE_P2_AVA_SELECTION,
} from '../constants';
import { CoreContext } from '../context/CoreContext';
import useNavigateBookingEngine from './useNavigateBookingEngine';
import { PRODUCT_FILTER_TYPE_BYTAG } from './useReadProductFilters';
import useWriteStorageBookingEngine from './useWriteStorageBookingEngine';

const useNavigateCartRule = () => {
  // eslint-disable-next-line no-unused-vars
  const [preCartData, setPreCartData] = useWriteStorageBookingEngine(LOCAL_STORAGE_PRECART, LOCAL_STORAGE_PRECART_DEFVAL);

  // This is to update the product tag filter before navigation
  const { coreData } = useContext(CoreContext);
  const { product_filter_type: productFilterType } = coreData.booking_engine;
  const [savedFilters, setSavedFilters] = useWriteStorageBookingEngine(LOCAL_STORAGE_FILTERS, LOCAL_STORAGE_FILTERS_DEFVAL);

  const navigate = useNavigateBookingEngine();

  const onCartRuleClick = cartRule => {
    setPreCartData(LOCAL_STORAGE_PRECART_DEFVAL);

    if (cartRule.effect_product != null && cartRule.effect_product.id != null) {
      navigate(`${ROUTE_P2_AVA_SELECTION}/${cartRule.effect_product.id}`);
      return;
    }

    if (productFilterType === PRODUCT_FILTER_TYPE_BYTAG) {
      setSavedFilters({
        ...savedFilters,
        [PRODUCTS_FILTERS.TAGS.fieldName]: cartRule.effect_product_tag != null ? cartRule.effect_product_tag.id : null,
      });
    }

    navigate(ROUTE_P1_PRODUCT_SELECTION);
  };

  return { onCartRuleClick };
};

export default useNavigateCartRule;
